import { SVGProps } from "react"

const OpenMask = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none" {...props}>
            <g clipPath="url(#clip0_1761_866)">
                <path d="M10.2852 1.15381L15.9994 24.2307L21.7137 1.15381H10.2852Z" fill="#A0DDFE" stroke="#A0DDFE" />
                <path d="M21.9429 1.15381L16 24.2307L29.7143 8.99996L21.9429 1.15381Z" fill="#88D3FF" stroke="#88D3FF" />
                <path d="M29.7143 9.23096L16 24.231L29.7143 21.0491V9.23096Z" fill="#73CBFF" stroke="#73CBFF" />
                <path d="M29.7143 20.769L16 24.0949L21.9429 28.846L29.7143 20.769Z" fill="#5BC1FF" stroke="#5BC1FF" />
                <path d="M21.7137 28.8463L15.9994 24.231L10.2852 28.8463H21.7137Z" fill="#80CFFF" stroke="#80CFFF" />
                <path d="M10.0566 28.846L15.9994 24.0949L2.28516 20.769L10.0566 28.846Z" fill="#95D9FF" stroke="#95D9FF" />
                <path d="M2.28516 21.0491L15.9994 24.231L2.28516 9.23096V21.0491Z" fill="#ADE2FF" stroke="#ADE2FF" />
                <path d="M2.28516 8.99996L15.9994 24.2307L10.0566 1.15381L2.28516 8.99996Z" fill="#B7E7FF" stroke="#B7E7FF" />
            </g>
        </svg>
    )
}

export default OpenMask